<template>
    <b-modal
        id="skilltree-rubric-management"
        v-model="modal"
        :title="$t('skill_tree.set_rubrics')"
        @ok="onOk"
        @close="onClose"
        :ok-title="$t('skill_tree.set_rubrics')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        size="lg"
        modal-class="apprentice-default-modal">
        <design-2021-apprentice-data-table
            :items="rubrics"
            :fields="fields"
            :key="'skill-tree-rubric-management-' + skillId">
            <template v-slot:cell(action)="row">
                <div class="rubric-actions actions">
                    <b-button
                        class="btn-settings btn-edit-skill-settings"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        @click="editRubricModalFunction(row.item)"
                        :title="$t('skill_tree.edit_settings')">
                    </b-button>
                    <b-button
                        class="btn-edit btn-edit-rubric"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('skill_tree.edit_rubric')"
                        @click="editRubric(row.item)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-skill-tree"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="deleteRubric(row.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <div class="new-rubric">
            <b-button
                class="btn-add btn-add-rubric"
                variant="primary"
                @click="makeNewRubric">
                {{ $t('skill_tree.new_rubric') }}
            </b-button>
        </div>

        <div v-if="newRubric">
            <design-2021-skilltree-rubric-management-levels-modal
                :count="skillSkillTree.rubrics ? skillSkillTree.rubrics.length + 1 : 1"
                :skill-id-in="skillId"
                :skill-skill-tree-in="skillSkillTree"
                @closeNewRubric="closeNewRubric"></design-2021-skilltree-rubric-management-levels-modal>
        </div>

        <div v-if="editRubricModal">
            <design-2021-skilltree-rubric-management-levels-edit-modal
                :skill-id-in="id"
                :rubric-in="editedRubric"
                @closeEditRubric="closeEditRubric"
                @updateRubric="updateRubric"></design-2021-skilltree-rubric-management-levels-edit-modal>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-skilltree-rubric-management-modal',
    data() {
        return {
            modal: false,
            newRubric: false,
            id: 0,
            editRubricModal: false,
            editedRubric: {},
            skillId: 0,
            subscription: null,
            skillSkillTree: null,
            fields: [
                {
                    key: 'title',
                    label: this.$t('common.title'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        rubrics() {
            return this.skillSkillTree ? this.skillSkillTree.rubrics : [];
        },
    },
    methods: {
        onClose() {
            this.subscription.unsubscribe();
            this.subscription = null;
        },

        updateRubric(response) {
            let newAttachedRubrics = [];

            for (const rubric of this.attachedRubric) {
                if (rubric.rubric_id === response.id) {
                    let data = {
                        title: response.title,
                        rubric_id: response.id,
                        rubricable_id: response.rubricable.id,
                        rubricable_skill_level_years: response.rubricable.rubricable_skill_level_years,
                    };

                    newAttachedRubrics.push(data);
                } else {
                    newAttachedRubrics.push(rubric);
                }
            }

            this.attachedRubric = newAttachedRubrics;
        },

        getEducationLevelsByEducationLevel(row) {
            let levels = [];
            let levelIds = [];

            for (const rubricable_skill_level_year of row.rubricable_skill_level_years) {
                if (rubricable_skill_level_year.school_education_level_skill_trees !== null) {
                    if (levels.length === 0) {
                        let data = {
                            id: rubricable_skill_level_year.school_education_level_skill_trees.school_education_levels
                                .id,
                            name: rubricable_skill_level_year.school_education_level_skill_trees.school_education_levels
                                .name,
                            years: [],
                        };

                        levelIds.push(
                            rubricable_skill_level_year.school_education_level_skill_trees.school_education_levels.id,
                        );

                        data.years.push(rubricable_skill_level_year.school_education_level_skill_trees.year);

                        levels.push(data);
                    } else {
                        for (const level of levels) {
                            if (
                                levelIds.includes(
                                    rubricable_skill_level_year.school_education_level_skill_trees
                                        .school_education_levels.id,
                                )
                            ) {
                                if (
                                    level.id ===
                                    rubricable_skill_level_year.school_education_level_skill_trees
                                        .school_education_levels.id
                                ) {
                                    let includes = level.years.includes(
                                        rubricable_skill_level_year.school_education_level_skill_trees.year,
                                    );

                                    if (!includes) {
                                        level.years.push(
                                            rubricable_skill_level_year.school_education_level_skill_trees.year,
                                        );
                                    }
                                }
                            } else if (
                                !levelIds.includes(
                                    rubricable_skill_level_year.school_education_level_skill_trees
                                        .school_education_levels.id,
                                )
                            ) {
                                let data = {
                                    id: rubricable_skill_level_year.school_education_level_skill_trees
                                        .school_education_levels.id,
                                    name: rubricable_skill_level_year.school_education_level_skill_trees
                                        .school_education_levels.name,
                                    years: [],
                                };

                                levelIds.push(
                                    rubricable_skill_level_year.school_education_level_skill_trees
                                        .school_education_levels.id,
                                );

                                data.years.push(rubricable_skill_level_year.school_education_level_skill_trees.year);

                                levels.push(data);
                            }
                        }
                    }
                }
            }

            return levels;
        },

        editRubricModalFunction(data) {
            this.editRubricModal = true;
            this.editedRubric = data;
        },

        closeEditRubric() {
            this.editRubricModal = false;
            this.editedRubric = {};
        },

        closeNewRubric() {
            this.newRubric = false;
        },

        editRubric(item) {
            window.location.href = this.routes.editRubric(item.id);
        },

        deleteRubric(item) {
            this.alert.saving();

            this.axios.delete(this.routes.skillDeleteRubric(item.id)).then(
                (response) => {
                    item.remove();

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        makeNewRubric() {
            this.newRubric = true;
        },

        onOk() {
            this.modal = false;
        },

        show(id) {
            this.newRubric = false;
            this.editRubricModal = false;
            this.modal = true;
            this.id = id;
            this.skillId = null;
            this.skillSkillTree = null;

            this.subscription = ords
                .use('skill_skill_trees')
                .with('skill')
                .with('rubrics', (rubricsCallback) => {
                    rubricsCallback.with('rubric');
                    rubricsCallback.with('rubric_skill_level_years', (callback) => {
                        callback.with('school_education_level_skill_trees', (schoolCallback) => {
                            schoolCallback.with('school_education_levels');
                        });
                    });
                })
                .find(id)
                .subscribe((skillSkillTree) => {
                    this.skillId = skillSkillTree.skill.id;
                    this.skillSkillTree = skillSkillTree;
                });
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    align-items: center;

    button:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

.new-rubric {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    align-content: center;
}

.rubric-actions {
    display: flex;
    align-items: center;

    .btn-edit-rubric {
        margin-left: map-get($grid-gutter-spacing, 'eight');
    }
}

.school-settings {
    .label {
        font-weight: $font-weight-bold;
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }

    .school-years {
        .year:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight') * 0.5;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .new-rubric {
        width: auto;
    }
}
</style>
